import classnames from "classnames";
import * as React from "react";
import * as _ from "underscore";
import Select from "react-select";

import { DocShape } from "@eave/shared/types/api";
import DocRender from "./DocRender";
import { docTypeToHumanStr, docToHumanStr } from "../shared";
import { docToFileName } from "./Documents/helpers";

require("assets/stylesheets/components/underwriter_dashboard/shared/doc_display.scss");

interface DocDisplayProps {
  docs: {
    length: number;
    [index: number]: DocShape;
  };
  onChangeDoc?: Function;
}

class DocDisplay extends React.Component<DocDisplayProps, any> {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  // TODO: jjw: would be nice to note last doc viewed for each type, then re-
  // select that specific doc when someone switches away and then back to type

  initialState() {
    const { docs } = this.props;

    let type = null;
    let id = null;

    const types = this.getDocTypeOptions();

    if (types.length) {
      type = types[0].value;

      // select first doc of type when changing types
      const docs = this.getDocsForTypeOptions(type);
      id = docs[0].value;
    }

    return {
      headerExpanded: docs.length > 1, // collapse if only one choice
      docType: type,
      docId: id,
      fileObjectURL: null,
    };
  }

  updateFileObjectURL(url) {
    this.setState({ fileObjectURL: url });
  }

  componentDidMount() {
    this.pushChange(this.state.docId);
  }

  getDocTypeOptions() {
    return _.chain(this.props.docs)
      .sortBy((d: any) => d.id) // not necessary, but gives types in natural (chrono) order
      .map((d: any) => d.type)
      .uniq()
      .map((t: any) => ({ value: t, label: docTypeToHumanStr(t) }))
      .value();
  }

  getDocsForTypeOptions(type) {
    return _.chain(this.props.docs)
      .filter((d: any) => d.type === type)
      .sortBy((d: any) => d.id)
      .map((d: any) => ({ value: d.id, label: docToHumanStr(d) }))
      .value();
  }

  toggleExpandHeader() {
    this.setState({
      headerExpanded: !this.state.headerExpanded,
    });
  }

  pushChange(docId) {
    const { onChangeDoc } = this.props;

    if (typeof onChangeDoc === "function") {
      onChangeDoc(docId);
    }
  }

  selectDocType(e) {
    let type = null;
    let id = null;

    if (e && e.value) {
      type = e.value;

      // select first doc of type when changing types
      const docs = this.getDocsForTypeOptions(type);
      id = docs[0].value;
    }

    const docId = id;

    this.setState(
      {
        docId,
        docType: e ? e.value : null,
      },
      this.pushChange.bind(this, docId),
    );
  }

  selectDocId(e) {
    const docId = e ? e.value : null;

    this.setState(
      {
        docId,
      },
      this.pushChange.bind(this, docId),
    );
  }

  getCurrentDoc() {
    const { docId } = this.state;
    if (docId === null) {
      // N.B. can be 0, so test null explicitly
      return null;
    }
    return _.findWhere(this.props.docs, { id: docId });
  }

  renderHeader() {
    const { headerExpanded, docType, docId } = this.state;

    const contentClasses = classnames({
      "doc-display__header-content": true,
      "doc-display__header-content--expanded": headerExpanded,
    });

    const chevronClasses = classnames({
      fa: true,
      "fa-chevron-up": headerExpanded,
      "fa-chevron-down": !headerExpanded,
    });

    const currentDoc = this.getCurrentDoc();

    return (
      <div className="doc-display__header">
        <div className="doc-display__header-control" onClick={this.toggleExpandHeader.bind(this)}>
          <i className={chevronClasses} />
        </div>
        <div className={contentClasses}>
          <div className="doc-display__select">
            <Select
              placeholder="Select type"
              clearable={false}
              searchable
              value={docType}
              options={this.getDocTypeOptions()}
              onChange={this.selectDocType.bind(this)}
            />
          </div>
          <div className="doc-display__arrow">
            <i className="fa fa-angle-double-right" />
          </div>
          <div className="doc-display__select">
            {docType && (
              <Select
                placeholder="Select document"
                clearable={false}
                searchable
                value={docId}
                options={this.getDocsForTypeOptions(docType)}
                onChange={this.selectDocId.bind(this)}
              />
            )}
          </div>
          {currentDoc && this.state.fileObjectURL != null && (
            <div className="doc-display__download">
              <a href={this.state.fileObjectURL} download={docToFileName(currentDoc)}>
                <i className="fa fa-cloud-download" />
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { docs } = this.props;

    if (!docs || !docs.length) {
      return (
        <div className="doc-display">
          <p>No documents found.</p>
        </div>
      );
    }

    const docClasses = classnames({
      "doc-display__pdf": true,
      "doc-display__pdf--smaller": this.state.headerExpanded,
    });

    return (
      <div className="doc-display">
        {this.renderHeader()}
        <div className={docClasses}>
          <DocRender
            doc={this.getCurrentDoc()}
            onFileObjectURLUpdate={this.updateFileObjectURL.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default DocDisplay;
